import VisitInformationIcon from '@/common/assets/icons/visitInformationIcon.svg?react';
import CustomIcon from '@/common/components/base/customIcon/CustomIcon';
import CustomLabel from '@/common/components/base/customLabel/CustomLabel';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import CardButton from '@/common/components/cardButton/CardButton';
import MainLayout from '@/common/components/layouts/MainLayout';
import { ADJUSTER_REPORT_CULPRIT_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritLinks';
import AdjusterImageIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/adjusterImageIcon.svg?react';
import AskedImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/askedImagesIcon.svg?react';
import ComplimentImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/complimentImagesIcon.svg?react';
import CroquisImageIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/croquisImageIcon.svg?react';
import SignatureImageIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/signatureImageIcon.svg?react';
import DocumentImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/documentImagesIcon.svg?react';
import { getImagesTabsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritImagesTabs/getImagesTabsQueryOptions';
import getCulpritImageTabsAlertsQueryOptions from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritImageTabsAlerts/getCulopritImageTabsAlertsQueryOptions';
import { getDamagedAdjusterImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterImages/getDamagedAdjusterImagesQueryOptions';
import { AdjusterTabImageCard } from '@/modules/adjusterReportModules/IncidentParticipants/types/entryTab.type';
import { HandleRoutesNavigation } from '@/modules/adjusterReportModules/IncidentParticipants/utils/HandleRoutesNavigation';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const CulpritImagesTabPage = () => {
  return (
    <MainLayout title=" مقصر  / تصاویر" header="titleHeader">
      <CulpritImagesTab />
    </MainLayout>
  );
};

const CulpritImagesTab = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: vehicleImages } = useQuery(
    getDamagedAdjusterImagesQueryOptions({
      id: +id!,
      enable: true,
      participantRoleType: 'culprit',
    }),
  );
  const { data } = useQuery(
    getImagesTabsQueryOptions({
      id: +id!,
      userType: 'culprit',
    }),
  );

  const { isPending } = useQuery(
    getCulpritImageTabsAlertsQueryOptions({
      id: +id!,
    }),
  );
  const renderRoute = (item: AdjusterTabImageCard<'culprit'>) => {
    const editable = item.editable;
    const culpritImagesLinks = ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_IMAGES({
      id: +id!,
    });

    let tabIcon: Record<AdjusterTabImageCard<'culprit'>['name'], string> = {
      adjuster_vehicle_image: HandleRoutesNavigation({
        edit: culpritImagesLinks.ADJUSTER_VEHICLE.damagedPoints,
        show: culpritImagesLinks.ADJUSTER_VEHICLE.showPreviewImages,
        editableAfterPost:
          culpritImagesLinks.ADJUSTER_VEHICLE.editablePreviewImages,
        isEditableAfterPost: !!vehicleImages?.vehicle.length,
        isEditable: editable,
      }),
      adjuster_document_image: HandleRoutesNavigation({
        edit: culpritImagesLinks.ADJUSTER_DOCUMENT.edit,
        show: culpritImagesLinks.ADJUSTER_DOCUMENT.show,
        isEditable: editable,
      }),
      adjuster_additional_image: HandleRoutesNavigation({
        edit: culpritImagesLinks.ADJUSTER_ADDITIONAL.edit,
        show: culpritImagesLinks.ADJUSTER_ADDITIONAL.show,
        isEditable: editable,
      }),
      croquis_image: HandleRoutesNavigation({
        edit: culpritImagesLinks.ADJUSTER_CROQUIS.edit,
        show: culpritImagesLinks.ADJUSTER_CROQUIS.show,
        isEditable: editable,
      }),

      signature: HandleRoutesNavigation({
        edit: culpritImagesLinks.SIGNATURE.edit,
        show: culpritImagesLinks.SIGNATURE.show,
        isEditable: editable,
      }),
      customer_vehicle_image: culpritImagesLinks.customerVehicle,
      customer_document_image: culpritImagesLinks.customerDocument,
      customer_additional_image: culpritImagesLinks.customerAdditional,

      corrective_image: culpritImagesLinks.corrective,
    };
    return tabIcon[item.name];
  };
  const goToFile = (item: AdjusterTabImageCard<'culprit'>) => {
    navigate(renderRoute(item));
  };

  return (
    <Box pt="2rem">
      {isPending ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        <Box
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            position: 'relative',
            top: '-5px',
          })}
        >
          <Box
            className={css({
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            })}
          >
            <TitleDescription>تصاویر کارشناس</TitleDescription>
            <Box>
              {data?.adjuster?.map(
                (item: AdjusterTabImageCard<'culprit'>, index) => (
                  <CardButton
                    key={item?.name}
                    cardProps={{
                      className: css({
                        marginY: '1rem',
                        marginTop: index === 0 ? '0rem' : '1rem',
                      }),
                      onClick: () => goToFile(item),
                    }}
                    hasArrow
                    renderTag={() =>
                      item?.label && (
                        <CustomLabel
                          title={item?.label?.fa_const}
                          color={
                            item?.label?.const === 'uncompleted'
                              ? 'black'
                              : 'green'
                          }
                        />
                      )
                    }
                    renderIcon={() => renderIcon(item.name)}
                    title={item?.fa_name}
                  />
                ),
              )}
            </Box>
            <Box>
              {data?.customer.exist ? (
                <TitleDescription>تصاویر مشتری</TitleDescription>
              ) : null}

              {data?.customer.exist &&
                data?.customer?.list?.map(
                  (item: AdjusterTabImageCard<'culprit'>, index) => {
                    if (!item.exists) return null;
                    return (
                      <>
                        <CardButton
                          key={item?.name}
                          cardProps={{
                            className: css({
                              marginY: '1rem',
                              marginTop: index === 0 ? '0rem' : '1rem',
                            }),
                            onClick: () => goToFile(item),
                          }}
                          hasArrow
                          renderTag={() =>
                            item?.label && (
                              <CustomLabel
                                title={item?.label?.fa_const}
                                color={
                                  item?.label?.const === 'uncompleted'
                                    ? 'black'
                                    : 'green'
                                }
                              />
                            )
                          }
                          renderIcon={() => renderIcon(item.name)}
                          title={item?.fa_name}
                        />
                      </>
                    );
                  },
                )}
            </Box>
          </Box>

          {data?.signature?.length ? (
            <>
              {data.signature.map((item: AdjusterTabImageCard<'culprit'>) => (
                <Box>
                  <TitleDescription>امضا مقصر</TitleDescription>
                  <CardButton
                    title={item?.fa_name!}
                    cardProps={{
                      className: css({ marginY: '1rem' }),
                      onClick: () => goToFile(item),
                    }}
                    renderIcon={() => renderIcon(item.name)}
                    hasArrow
                    renderTag={() =>
                      item?.label && (
                        <CustomLabel
                          title={item?.label?.fa_const}
                          color={
                            item?.label?.const === 'uncompleted'
                              ? 'black'
                              : 'green'
                          }
                        />
                      )
                    }
                  />
                </Box>
              ))}
            </>
          ) : null}
          {data?.corrective_image?.length
            ? data?.corrective_image?.map(
                (item: AdjusterTabImageCard<'culprit'>) => (
                  <>
                    <Box>
                      <TitleDescription>تصاویر درخواستی</TitleDescription>
                      <CardButton
                        title={item?.fa_name!}
                        cardProps={{
                          className: css({ marginY: '1rem' }),
                          onClick: () => {
                            goToFile(item);
                          },
                        }}
                        renderIcon={() => renderIcon(item.name)}
                        hasArrow
                        renderTag={() => (
                          <CustomLabel title={item?.count!} color={'orange'} />
                        )}
                      />
                    </Box>
                  </>
                ),
              )
            : null}
        </Box>
      )}
    </Box>
  );
};
export default CulpritImagesTabPage;
const renderIcon = (tabName: AdjusterTabImageCard<'culprit'>['name']) => {
  let tabIcon: Record<
    AdjusterTabImageCard<'culprit'>['name'],
    React.JSX.Element
  > = {
    adjuster_vehicle_image: (
      <CustomIcon backgroundColor="orange-3" width={40} height={40}>
        <VisitInformationIcon stroke={token('colors.orange')} />
      </CustomIcon>
    ),
    adjuster_additional_image: <ComplimentImagesIcon />,
    adjuster_document_image: <DocumentImagesIcon />,

    customer_vehicle_image: (
      <CustomIcon backgroundColor="green-4" width={40} height={40}>
        <VisitInformationIcon />
      </CustomIcon>
    ),
    customer_additional_image: <ComplimentImagesIcon />,
    customer_document_image: <AdjusterImageIcon />,

    corrective_image: <AskedImagesIcon />,
    signature: <SignatureImageIcon />,
    croquis_image: <CroquisImageIcon />,
  };
  return tabIcon[tabName];
};
